<template>
  <div class="filter-dropdown">
    <div style="display: flex; align-items: center">
      <small class="one-line ma-0 pa-5" style="min-width: 120px">
        {{ label }}
      </small>
      <v-icon v-if="sortable" color="#fff" @click="$emit('sort')">
        mdi-sort
      </v-icon>
      <v-icon
        v-if="filterable"
        color="#fff"
        @click.stop="$emit('filter-click')"
      >
        mdi-filter-menu-outline
      </v-icon>
    </div>
    
    <!-- Filter modal dialog -->
    <v-dialog
      v-model="isOpen"
      max-width="600px"
    >
      <v-card>
        <v-toolbar :color="$vuetify.theme.dark ? 'primary' : '#2562eb'" dark>
          <v-card-title class="d-flex justify-content-center text-body-2 text-lg-h6 align-items-center">
            Filtrer par {{ label }}
          </v-card-title>
        </v-toolbar>
        <v-card-title class="pa-0">
          <v-select
            v-if="filterable && fieldName !== 'dateDF'"
            @input="updateFilter"
            v-model="selectedItems"
            :items="filterItems"
            hide-no-data
            dense
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <v-tooltip v-if="typeof item === 'string' && item.length >= 15" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <small class="td-table" v-bind="attrs" v-on="on">
                      {{ item.substring(0, 20) + "..." }}
                    </small>
                  </template>
                  <span>{{ item }}</span>
                </v-tooltip>
                <small class="td-table" v-else>
                  {{ item }}
                </small>
              </v-chip>
              <span v-if="index === 1" class="grey--text text-caption">
                (+{{ filterItems.length - 1 }}
                {{ filterItems.length - 1 > 1 ? "éléments" : "élément" }})
              </span>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple class="pa-0">
                <v-list-item-content>
                  <div class="d-flex justify-space-between">
                    <v-btn
                      class="mx-2"
                      style="cursor: pointer"
                      @click="selectAll"
                    >
                      <v-icon>mdi-select-remove</v-icon>
                      Cliquez pour tout sélectionner
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select>
          
          <!-- Date range picker for dateDF field -->
          <div v-if="fieldName === 'dateDF'">
            <small class="pa-2">
              Sélectionnez deux dates pour définir un intervalle
            </small>
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  dense
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateRange" no-title range scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateMenu = false">
                  Annuler
                </v-btn>
                <v-btn text color="primary" @click="applyDateFilter">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'FilterDropdown',
  props: {
    label: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    filterable: {
      type: Boolean,
      default: false
    },
    sortable: {
      type: Boolean,
      default: false
    },
    filterItems: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedItems: [],
      isOpen: false,
      dateRange: [],
      dateMenu: false
    };
  },
  computed: {
    dateRangeText() {
      return this.dateRange.join(' ~ ');
    }
  },
  watch: {
    show(newVal) {
      this.isOpen = newVal;
    },
    isOpen(newVal) {
      this.$emit('update:show', newVal);
    }
  },
  methods: {
    updateFilter() {
      this.$emit('filter-update', {
        field: this.fieldName,
        values: this.selectedItems
      });
    },
    selectAll() {
      if (this.selectedItems.length === this.filterItems.length) {
        this.selectedItems = [];
      } else {
        this.selectedItems = [...this.filterItems];
      }
      this.updateFilter();
    },
    applyDateFilter() {
      this.$emit('date-filter', {
        min: this.dateRange[0],
        max: this.dateRange[1]
      });
      this.dateMenu = false;
      this.isOpen = false;
    }
  }
}
</script>

<style scoped>
.one-line {
  text-align: center;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
}
</style>